import { render, staticRenderFns } from "./CleaningForm.vue?vue&type=template&id=66edf05d&scoped=true&"
import script from "./CleaningForm.vue?vue&type=script&lang=js&"
export * from "./CleaningForm.vue?vue&type=script&lang=js&"
import style0 from "./CleaningForm.vue?vue&type=style&index=0&id=66edf05d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66edf05d",
  null
  
)

export default component.exports